import * as React from "react"
import { Box, Chip } from "@mui/material"

import { PRODUCT_PAGES_IMAGES_DETAILS_STATUS } from "../../constants"


export default function statusColumn() {
    return [{
        name: 'status', label: 'Status',
        options: {
            display: 'excluded',
            filterOptions: { names: [PRODUCT_PAGES_IMAGES_DETAILS_STATUS.GOOD, PRODUCT_PAGES_IMAGES_DETAILS_STATUS.FIX] }
        }
    }, {
        name: 'status', label: 'Status',
        options: {
            filter: false,
            setCellHeaderProps: () => ({ sx: { minWidth: 80 } }),
            customBodyRowRender: value => {
                if (!value) return <Box sx={{ textAlign: 'center' }}>--</Box>
                const isGood = value === PRODUCT_PAGES_IMAGES_DETAILS_STATUS.GOOD
                return <Box sx={{ textAlign: 'center' }}>
                    <Chip
                        label={value}
                        size="small"
                        sx={{
                            borderRadius: '50%',
                            width: 48,
                            height: 48,
                            fontSize: 11,
                            fontWeight: 'bold',
                            bgcolor: isGood ? 'success.main' : 'error.main',
                            color: 'white',
                            '& .MuiChip-label': { px: 0 }
                        }}
                    />
                </Box>
            }
        }
    }]
}
